import { CancelToken } from 'axios'

import { getFormData } from 'Shared/utils/formData'

import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils'

import { Invoice } from 'Portals/Supplier/entities'

import { baseUrl } from './constants'

export const getList = (
	params: TableUrlParams,
	additionalParams?: TableUrlParams
): Promise<{ items: Invoice.Basic[]; total: number }> =>
	Http.get(`${baseUrl}`, { params: { ...params, ...additionalParams } })

export const searchSuggestions = (
	params: TableUrlParams,
	cancelToken?: CancelToken
): Promise<string[]> => Http.get(`${baseUrl}/search-suggestions`, { params, cancelToken })

export const downloadInvoiceDocument = (
	invoiceId: number,
	documentId: number
): Promise<ArrayBuffer> =>
	Http.get(`${baseUrl}/${invoiceId}/documents/${documentId}/download`, {
		responseType: 'arraybuffer'
	})

export const retrieveSupplierLocations = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/supplier-locations`)

export const retrieveInvoiceById = (id: Key): Promise<Invoice.Edit.Basic> =>
	Http.get(`${baseUrl}/${id}`)

export const retrieveShortPays = (id: string): Promise<Invoice.Edit.ShortPays[]> =>
	Http.get(`${baseUrl}/${id}/short-pays`)

export const cancelInvoice = (id: number): Promise<void> => Http.put(`${baseUrl}/${id}/cancel`)

export const uploadInvoice = (data: Invoice.Add.Request.Add): Promise<number> => {
	const formData = getFormData<Invoice.Add.Request.Add>(data)

	return Http.post(`${baseUrl}`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
}

export const retrieveBackupDocument = (id: string): Promise<Invoice.Edit.BackupDocument.Basic> =>
	Http.get(`${baseUrl}/${id}/backup-documents`)

export const uploadBackupDocument = ({
	id,
	data
}: {
	id: Key
	data: Invoice.Edit.BackupDocument.Request.Add
}): Promise<void> => {
	const formData = getFormData<Invoice.Edit.BackupDocument.Request.Add>(data)

	return Http.post(`${baseUrl}/${id}/backup-documents`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
}

export const retrieveDocumentTypes = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/backup-documents/types`)

export const downloadBackupDocument = (
	invoiceId: number,
	documentId: number
): Promise<ArrayBuffer> =>
	Http.get(`${baseUrl}/${invoiceId}/backup-documents/${documentId}/download`, {
		responseType: 'arraybuffer'
	})

export const removeDocument = (invoiceId: number, documentId: number): Promise<void> =>
	Http.delete(`${baseUrl}/${invoiceId}/backup-documents/${documentId}`)
